var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGhana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9999C0 22.4463 0.440078 24.7898 1.24398 26.9564L20 27.826L38.756 26.9565C39.56 24.7898 40 22.4463 40 19.9999C40 17.5535 39.56 15.2101 38.756 13.0434L20 12.1738L1.24398 13.0434C0.440078 15.2101 0 17.5535 0 19.9999H0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 -3.8147e-05C11.4007 -3.8147e-05 4.06988 5.42746 1.24402 13.0435H38.7561C35.9302 5.42746 28.5993 -3.8147e-05 20 -3.8147e-05V-3.8147e-05Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7561 26.9564H1.24402C4.06988 34.5723 11.4007 39.9999 20 39.9999C28.5993 39.9999 35.9302 34.5723 38.7561 26.9564Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 13.0434L21.7264 18.3575H27.3145L22.7939 21.6421L24.5205 26.9564L19.9998 23.672L15.4791 26.9564L17.206 21.6421L12.6854 18.3575H18.2732L19.9998 13.0434Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhana);
export default __webpack_public_path__ + "static/media/ghana.c3cad972baac9a5370c5b3209f274bf5.svg";
export { ForwardRef as ReactComponent };